var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteCartItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.94 104.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete-cart-item") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.05,0A25.9,25.9,0,1,1,78.72,7.59,25.91,25.91,0,0,1,97.05,0ZM3.71,10.89a3.71,3.71,0,0,1,0-7.42H9.16a17.24,17.24,0,0,1,8.89,2.34c4.92,3.12,5.79,7.57,7,12.59h41.7a31.23,31.23,0,0,0-.9,7.33H27.19l8.36,31.46H94.82V57c.72.05,1.44.08,2.17.08a31.22,31.22,0,0,0,5.46-.48l-1.29,5.18a3.62,3.62,0,0,1-3.57,2.82H37.52c1.32,4.88,2.63,7.51,4.42,8.74,2.16,1.4,5.92,1.5,12.21,1.4H96.69a3.67,3.67,0,1,1,.38,7.33,2.41,2.41,0,0,1-.38,0H54.24c-7.79.09-12.58-.09-16.44-2.63s-6-7.14-8.07-15.31h0L17.14,16.52c0-.09,0-.09-.09-.19a6.52,6.52,0,0,0-2.82-4.22,9.57,9.57,0,0,0-5.18-1.22ZM60.92,33.47a2.6,2.6,0,0,1,5.11,0V47.63a2.6,2.6,0,0,1-5.11,0Zm-15.3,0a2.6,2.6,0,0,1,5.11,0V47.63a2.6,2.6,0,0,1-5.11,0ZM85.71,86.4a9,9,0,1,1-9,9h0A9,9,0,0,1,85.71,86.4Zm-39.55,0a9,9,0,1,1-9,9h0A9,9,0,0,1,46.16,86.4Zm64.08-62.91V28.3a2.09,2.09,0,0,1-2.07,2.07H85.9a2.09,2.09,0,0,1-2.07-2.07V23.49a2.07,2.07,0,0,1,2.07-2.07h22.27A2.09,2.09,0,0,1,110.24,23.49Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCartItem);
export default __webpack_public_path__ + "static/media/delete-cart-item.b7653f9ced295b8db5871a4155fcfdf5.svg";
export { ForwardRef as ReactComponent };